/* eslint-disable */
import { permissionsMessages } from '@ringcentral-integration/commons/enums/permissionsMessages';
export default {
  [permissionsMessages.callingDisable]:
    'Sie verfügen nicht über ausreichende Berechtigungen, um ausgehende Anrufe zu tätigen. Wenden Sie sich an Ihren {brand}-Kontoadministrator, um ein Upgrade zu erhalten.',
} as const;

// @key: @#@"[permissionsMessages.callingDisable]"@#@ @source: @#@"You don't have permissions to place outbound calls. Please contact your {brand} account administrator for an upgrade."@#@
